import { CardInfo, RedeemFillMediumIcon } from '@ferreri/prever-component-lib';
import { SETTINGS } from '../../config/settings';

export const RewardsUrl = `${SETTINGS.public.urlClubePublicationWeb}/rewards`;

const handleRedirect = () => {
  window.location.assign(RewardsUrl);
};

export const RewardsSection = () => {
  return (
    <CardInfo
      title="Resgate de recompensas"
      icon={<RedeemFillMediumIcon />}
      labelButtonSecondary="Confira "
      onClickButtonSecondary={handleRedirect}
      tag="Novo"
    >
      Resgate suas recompensas recebidas pelas suas indicações.
    </CardInfo>
  );
};
